import moment from 'moment';
import React from 'react';
// Scope of the Research Notification
const TenStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    specific_topic,
    specific_field,
    conference_name,
    conference_short_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    registration_link,
    paper_title,
    your_name,
    contact_details
  } = values;
  return (
    <div>
      <p>{client_name ? `Hi ${client_name},` : `Hi [Lead's Name],`}</p>

      <p>
        Your research on {specific_topic ? specific_topic : `[specific topic]`}{' '}
        is a great fit for{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short
        Name]`}
        </strong>
        , a CPD-accredited event on{' '}
        <strong>
          {conference_from_date && conference_to_date
            ? `${conference_from_date} - ${conference_to_date}`
            : `[Conference from and to Date]`}
        </strong>{' '}
        at{' '}
        <strong>
          {conference_location ? conference_location : `[Conference Location]`}
        </strong>
        .
      </p>

      <p>
        Presenting your paper, “<strong>{paper_title ? paper_title : `[Paper Title]`}</strong>
        ,”{' '}will help you:
      </p>

      <p>
        🌟 Gain global recognition <br />
        🌟 Publish in Scopus-indexed journals <br />
        🌟 Earn a CPD certification
      </p>

      <p>
        {registration_link ? (
          <>
            Register Now:{' '}
            <a
              href={registration_link}
              target="_blank"
              // rel="noopener noreferrer"
            >
              
              {registration_link}
            </a>
          </>
        ) : (
          'Register Here: [Registration Link]'
        )}
      </p>
      <p>
        Let me know if you have any questions. Looking forward to seeing you
        there!
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default TenStepWhatsappTemplate;
